import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import AddCircle from '@mui/icons-material/AddCircle';
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import CircularProgress from '@mui/material/CircularProgress';

import { objectToQueryString, baseUrl, apiHelper } from 'helpers/util';

import ColumnBox from 'components/ColumnBox';
import SmallHeading from 'components/SmallHeading';

export default function Form(props) {

    const [contentType, setContentType] = useState(null);
    const [contentTitle, setContentTitle] = useState('');
    const [description, setDescription] = useState('');
    const [selectedFileName, setSelectedFileName] = useState(null);
    const [imageBase64, setImageBase64] = useState(null);
    const [isFormSubmitting, setIsFormSubmitting] = useState(false);
    const [postedBy, setPostedBy] = useState('admin');
    const [url, setUrl] = useState('');
    const [errorMessage, setErrorMessage] = useState('');


    const contentTypeOptions = ["Text Only", "Image", "Video (Link)", "Audio (Link)"];
    const onClickSave = function () {
        if (contentType == 'Image' && !imageBase64) {
            setErrorMessage('Please upload image file and retry');
            return;
        }
        if ((contentType == 'Video (Link)' || contentType == 'Audio (Link)') && !url) {
            setErrorMessage('Please provide link to video/audio and retry');
            return;
        }
        if(!contentTitle) {
            setErrorMessage('Please provide title and retry');
            return;
        }
        const payload = {
            "title": contentTitle, 'media_type': contentType,
            "url": url, "short_description": description,
            "posted_by": postedBy, "image_base64": imageBase64, "image_filename": selectedFileName
        }
        setIsFormSubmitting(true);
        let apiUrl = `${baseUrl}/.netlify/functions/feed_create`;
        let apiPromise = null;
        apiPromise = apiHelper.post({ "url": apiUrl, "data": payload })

        apiPromise
            .then(response => {
                if (response.status) {
                    console.log("Tweet created successfully");
                    resetData();
                } else { console.log(response.json); }
                setIsFormSubmitting(false);
            })
    }

    const onFileSelected = function (files) {
        if (files && files.length > 0) {
            setSelectedFileName(files[0].name);
            var reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = function () {
                setImageBase64(reader.result.split(',')[1]);
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        }
    }

    const resetData = function () {
        setContentType(null);
        setContentTitle('');
        setDescription('');
        setSelectedFileName('');
    }

    return (
        <Box sx={{
            display: 'flex', flexDirection: 'row', justifyContent: 'center',
            padding: '15px'
        }}>
            <ColumnBox sx={{
                alignItems: 'center', maxWidth: '500px',
                width: '100%'
            }}>
                <SmallHeading>Tweet Details</SmallHeading>

                <Autocomplete
                    disablePortal
                    size="small"
                    onChange={(e, newValue) => { setContentType(newValue); }}
                    options={contentTypeOptions}
                    value={contentType}
                    sx={{ width: '100%', marginTop: '15px' }}
                    renderInput={(params) => <TextField {...params} label="Media Type" />}
                />
                <TextField label="Tweet Title" size="small"
                    sx={{ width: '100%', marginTop: '15px' }}
                    onChange={(e) => { setContentTitle(e.target.value); }}
                    value={contentTitle} />
                <TextField label="Short Description"
                    sx={{ width: '100%', marginTop: '15px' }}
                    minRows={2}
                    onChange={(e) => { setDescription(e.target.value); }}
                    value={description}
                    multiline={true} />
                {contentType === "Image" &&
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', marginTop: '10px' }}>
                        <Button sx={{ margin: '0 5px 0 0' }}
                            variant="outlined"
                            component="label"
                            required={contentType === "image"}
                            startIcon={<UploadFileIcon />}>Upload Image
                            <input type="file"
                                onChange={(e) => {
                                    onFileSelected(e.target.files);
                                }} hidden />
                        </Button>
                        <Box><i>{selectedFileName || ''}</i></Box>
                    </Box>
                }

                {contentType === "Video (Link)" &&
                    <TextField label="Link to Video" size="small"
                        sx={{ width: '100%', marginTop: '15px' }}
                        onChange={(e) => { setUrl(e.target.value); }}
                        required={contentType === "Video (Link)"}
                        value={url} />
                }

                {contentType === "Audio (Link)" &&
                    <TextField label="Link to Audio" size="small"
                        sx={{ width: '100%', marginTop: '15px' }}
                        onChange={(e) => { setUrl(e.target.value); }}
                        required={contentType === "Audio (Link)"}
                        value={url} />
                }

                {errorMessage && (
                    <Box sx={{ color: 'red', marginTop: '15px' }}>
                        {errorMessage}
                    </Box>
                )}


                {isFormSubmitting ? <CircularProgress sx={{ marginTop: '15px' }} /> :
                    <Button sx={{ marginTop: '15px' }} onClick={() => onClickSave()}
                        variant="outlined">Save</Button>
                }
            </ColumnBox>
        </Box>
    );
}
